"use client";

import { c as _c } from "react/compiler-runtime";
import type { CSSProperties } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
interface CarouselArrowProps {
  readonly direction: "left" | "right";
  readonly onClick: () => void;
  readonly disabled?: boolean;
  readonly placement?: "floating" | "inline";
  readonly className?: string;
  readonly style?: CSSProperties;
}
export default function CarouselArrow(t0) {
  const $ = _c(9);
  const {
    direction,
    onClick,
    disabled: t1,
    placement: t2,
    className: t3,
    style
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const placement = t2 === undefined ? "floating" : t2;
  const className = t3 === undefined ? "" : t3;
  const isLeft = direction === "left";
  const placementClasses = placement === "inline" ? "tw-static tw-translate-x-0 tw-translate-y-0" : "tw-absolute tw-top-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2";
  const t4 = isLeft ? "Previous" : "Next";
  const t5 = `${placementClasses} tw-z-20 tw-flex tw-h-11 tw-w-11 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-border-white/10 tw-bg-white/20 tw-text-white tw-backdrop-blur-md tw-transition-all tw-duration-300 hover:tw-border-white/20 hover:tw-bg-white/[0.15] disabled:tw-cursor-not-allowed disabled:tw-opacity-40 disabled:hover:tw-border-white/10 disabled:hover:tw-bg-white/10 ${className}`;
  const t6 = `tw-size-4 tw-shrink-0 ${isLeft ? "" : "tw-rotate-180"}`;
  let t7;
  if ($[0] !== t6) {
    t7 = <FontAwesomeIcon icon={faChevronLeft} className={t6} />;
    $[0] = t6;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  let t8;
  if ($[2] !== disabled || $[3] !== onClick || $[4] !== style || $[5] !== t4 || $[6] !== t5 || $[7] !== t7) {
    t8 = <button type="button" onClick={onClick} disabled={disabled} aria-label={t4} className={t5} style={style}>{t7}</button>;
    $[2] = disabled;
    $[3] = onClick;
    $[4] = style;
    $[5] = t4;
    $[6] = t5;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  return t8;
}